import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Item from "./Item";
import {
  getLocalPhoneNumber,
  getFullName,
} from "../../../components/util/helpers";
const { Title } = Typography;

const PatientDetails = (props) => {
  const { order } = props;
  const intl = useIntl();
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );

  const getAddress = () => {
    const address = activePatient.address || {};
    const street = address.street
      ? `${address.street} ${address.house_number || ""}`.trim()
      : "";
    const city = address.city || "";
    return city ? `${city}${street ? ", " + street : ""}` : street;
  };

  const address = getAddress();

  const getLocalId = () => {
    return activePatient?.local_id_number?.padStart(9, "0");
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="section" style={{ width: "100%" }}>
        <Title level={5}>
          {intl.formatMessage({
            id: "app.orders.patient_details",
          })}
        </Title>
        <div className="rowContainer">
          <Item
            name="patient_name"
            content={getFullName(
              activePatient.surename,
              activePatient.first_name
            )}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item
            name="patient.local_id_number"
            content={getLocalId()}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item name="patient_address" content={address} line_type="vertical" />
          <div className="horizontal_spacer" />
          <Item
            name="patient.contact_info.phone_number"
            content={getLocalPhoneNumber(
              activePatient.contact_info.phone_number
            )}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item
            name="client.name"
            content={order["client.name"]}
            line_type="vertical"
          />
        </div>
      </div>
    </div>
  );
};

export default PatientDetails;
